import { getTypographyStyles } from '@oneaudi/unified-web-common';

// Utility function to map `size` to typography styles
export const getTypographyBySize = (
  size: 'small' | 'medium' | 'large',
  sm: object,
  md: object,
  lg: object,
) => {
  switch (size) {
    case 'small':
      return getTypographyStyles(sm);
    case 'medium':
      return getTypographyStyles(md);
    default:
      return getTypographyStyles(lg);
  }
};
